import * as ko from "knockout";
import {ICompany, IMessageData, IRouteDefinitionParams} from "../../../index";
import {nsRoute} from "../../../util/route";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;

export abstract class Abstract extends ParsedRouteDataDecorator {
    protected comments: KnockoutObservable<string | null> = ko.observable(null);
    protected data: ICompany | null = null;
    protected isReady: KnockoutObservable<boolean> = ko.observable(false);
    protected messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.initRequest();
    }


    protected initRequest(): Promise<void> {
        this.data = null;
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        return this.__requestRouteData!
            .request()
            .then((data: ICompany[]) => {
                this.data = data[0] ?? null;
                this.comments(this.data?.comment || '');
            })
    }

}